import React from "react";
import {makeStyles} from '@material-ui/core/styles';
import {Tabs, Tab, Box, Typography} from '@material-ui/core';
import TabPanel from '../../core/TablPanel';

import {Card} from "../../../../_metronic/_partials/controls";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

function tabProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

export function StatisticsForProductsContainer() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Card className={classes.root}>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        centered
      >
        <Tab label={<span className="font-size-lg">상품</span>} {...tabProps(1)} />
        <Tab label={<span className="font-size-lg">카테고리</span>} {...tabProps(2)} />
      </Tabs>

      <TabPanel value={value} index={0}>
        <Box p={4}>
          <Typography>상품 탭</Typography>
        </Box>
      </TabPanel>

      <TabPanel value={value} index={1}>
        <Box p={4}>
          <Typography>카테고리 탭</Typography>
        </Box>
      </TabPanel>
    </Card>
  );
}

